import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, combineLatest, of } from 'rxjs';
import { filter, switchMap, tap } from 'rxjs/operators';
import { AuthStore } from '@store';

@Injectable()
export class ForbiddenForRsaGuardService {
  constructor(private authStore: AuthStore, private router: Router) {}

  canMatch(): Observable<boolean> {
    return this.checkAuth();
  }

  private checkAuth(): Observable<boolean> {
    return combineLatest([
      this.authStore.isAuthorized$,
      this.authStore.isRsaUser(),
      this.authStore.isAuthorizing$,
      this.authStore.isAuthenticating$,
    ]).pipe(
      tap(([isAuthorized, _rsa, isAuthorizing, isAuthenticating]) => {
        if (!isAuthorized && !isAuthorizing && !isAuthenticating) {
          // User not logged nor logging - prevent from whitespace
          this.router.navigate(['/home']);
        }
      }),
      filter(([isAuthorized]) => isAuthorized === true),
      switchMap(([_isAuthorized, isRsaUser]) => {
        if (isRsaUser) {
          this.router.navigate(['/home']);

          return of(false);
        } else {
          return of(true);
        }
      })
    );
  }
}
